module.exports = __webpack_public_path__ + "static/media/Apple Watch 44mm Titanium + Red Open.9f318b86.png";